import { render, staticRenderFns } from "./DashboardReport.vue?vue&type=template&id=50f8f6c8&"
import script from "./DashboardReport.vue?vue&type=script&lang=js&"
export * from "./DashboardReport.vue?vue&type=script&lang=js&"
import style0 from "./DashboardReport.vue?vue&type=style&index=0&id=50f8f6c8&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports